export default __webpack_public_path__ + "static/media/stamp9.7b9e219d.png";